export const ArchiveIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '16'}
    height={props?.height || '14'}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 4.33333V13H2.00008V4.33333M6.66675 7H9.33341M0.666748 1H15.3334V4.33333H0.666748V1Z"
      stroke={props?.color || '#B42318'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
